<template>
  <auth-layout ilustracao="email" :slides="slides">
    <form class="form" novalidate @submit.prevent="recuperarAcesso">
      <router-link class="back-link" :to="{ name: 'login' }">← Voltar para o login</router-link>
      <h1 class="form__title">Esqueceu a senha?</h1>
      <p class="form__sub">Informe o e-mail da sua conta e enviaremos um link para você criar uma nova senha.</p>

      <div class="field" :class="{ 'field--error': erroEmail }">
        <label class="field__label" for="esqueci-email">E-mail</label>
        <input
          id="esqueci-email"
          v-model.trim="formCad.email"
          class="field__input"
          type="email"
          autocomplete="email"
          placeholder="nome@empresa.com.br"
          @input="erroEmail && validarEmail()"
        />
        <div v-if="erroEmail" class="field__msg">{{ erroEmail }}</div>
      </div>

      <button class="btn" type="submit" :disabled="!!erroEmail || loading">
        <v-progress-circular v-if="loading" indeterminate size="20" width="2" color="#FFD400" />
        <span v-else>Enviar link</span>
      </button>
    </form>
  </auth-layout>
</template>

<script>
import AuthLayout from "@/components/auth/AuthLayout.vue";
import { emailValido } from "@/components/auth/auth.js";

export default {
  components: { AuthLayout },
  data: () => ({
    slides: [
      {
        titulo: "Recupere seu acesso",
        subtitulo: "O link para criar uma nova senha chega no e-mail cadastrado na sua conta.",
      },
    ],
    loading: false,
    erroEmail: "",
    formCad: {
      email: null,
    },
  }),

  methods: {
    validarEmail() {
      this.erroEmail = emailValido(this.formCad.email) ? "" : "Informe um e-mail válido.";
      return !this.erroEmail;
    },

    recuperarAcesso() {
      if (this.loading || !this.validarEmail()) return;

      this.loading = true;
      this.$http
        .post(`recuperaracesso`, {
          email: this.formCad.email,
        })
        .then(() => {
          this.$swal({
            toast: true,
            position: "center",
            showConfirmButton: false,
            background: "#4BB543",
            timer: 3000,

            title:
              '<span style="color:#FFF; font-family: Inter">Email para recuperação de senha enviado.</span>',
          });
          this.loading = false;
          this.$router.push({ name: "login" });
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);

          this.$swal({
            toast: true,
            position: "center",
            showConfirmButton: false,
            background: "#ff0000",
            timer: 3000,

            html: '<span style="color:#FFF">Não foi possível localizar e-mail de acesso.</span>',
          });
        });
    },
  },
};
</script>

<style scoped src="@/components/auth/auth-form.css"></style>
